import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, collectionData, deleteDoc, doc, docData, getDocs, orderBy, query, updateDoc } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Area } from '../models/area';

@Injectable()
export class AreaService {

  constructor(
    private firestore: Firestore) {

  }

  read(id: string, sectionId: string, reportId: string) {
    // This method should return an observable of one area
    // It can be implemented to fetch areas from a Firestore collection
    // For example:

    const areaDocRef = doc(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas/' + id);
    return docData(areaDocRef) as Observable<Area>;
  }

  /**
   * Retorna un observable de áreas por reportId
   * @param sectionId
   * @param reportId
   * @returns
   */
  readObservablesByReportId(sectionId: string, reportId: string): Observable<any[]> {
    // This method should return an observable of areas by reportId
    const areasCollection = collection(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas');
    const areasQuery = query(areasCollection, orderBy('date', 'asc'));

    return collectionData(areasQuery, { idField: 'id' }) as Observable<any[]>;
  }

  async readSnaphotsByReportId(sectionId: string, reportId: string): Promise<{ id: string, data: Area }[]> {
    const areasCollection = collection(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas');
    const areasQuery = query(areasCollection, orderBy('date', 'asc'));

    const snapshot = await getDocs(areasQuery);

    return snapshot.docs.map((doc) => {
        return { id: doc.id, data: doc.data() as Area };
    });
  }


  async createAsync(sectionId: string, reportId: String, id: string, areaData: Area, createdBy: string) {
    // This method should implement the logic to create a new area
    // It can be implemented to add a new document to a Firestore collection
    // For example:
    const areasCollection = collection(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas/' + id);

    const snapshot = await getDocs(areasCollection);
    areaData.order = snapshot.size + 1; // Set the order based on the current size of the collection

    return addDoc(areasCollection, {
      name: areaData.name,
      order: snapshot.size + 1,
      date: new Date(),
      createdBy: createdBy,
    });
  }

  update(sectionId: string, reportId: string, id: string, name, modifiedBy: string ) {
    // This method should implement the logic to update an existing area
    // It can be implemented to update a document in a Firestore collection
    // For example:
    // const areaDocRef = doc(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas/' + id);
    // return updateDoc(areaDocRef, areaData);
     const areaDocRef = doc(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas/' + id);
     return updateDoc(areaDocRef, { name: name, modifiedBy: modifiedBy  });
  }

  /**
   * Delete an area by Id
   * @param sectionId
   * @param reportId
   * @param areaId
   * @returns
   */
  async deleteAsync(sectionId: string, reportId: string, areaId: string): Promise<void> {
    const areaDocRef = doc(this.firestore, 'sections/' + sectionId + '/templates/' + reportId + '/areas/' + areaId);
    return deleteDoc(areaDocRef);
  }
}
